export const MAP_SECURITY_TAB_FORM = {
  ALARMS: 'securityAlarms',
  CAMERAS: 'securityCameras',
};
